module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "title"
  }, [_c('h2', [_vm._v(_vm._s(_vm.dealName))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.showProductTc
    }
  }, [_vm._v("切换产品")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d2e413c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/comment/list/components/title/Title.vue
// module id = 703
// module chunks = 0